import { AddActivity, LoadAllActivities, RemoveActivity, Activity } from "./exampleOperations";

interface State {
  activities: Activity[];
}

const INITIAL_STATE: State = {
  activities: [],
};

type Actions = AddActivity | RemoveActivity | LoadAllActivities;

const manageState = (state = INITIAL_STATE, action: Actions) => {
  switch (action.type) {
    case "ADD_ACTIVITY": {
      const activitiesList = [...state.activities];
      const { activity } = action.payload;

      activitiesList.push(activity);

      return { ...state, activities: activitiesList };
    }
    case "RM_ACTIVITY": {
      const { id } = action.payload;
      const activitiesList = [...state.activities].filter((activity) => activity.id !== id);

      return { ...state, activities: activitiesList };
    }
    case "LOAD_ALL_ACTIVITIES": {
      const { activities } = action.payload;

      return { ...state, activities };
    }
    default: {
      return state;
    }
  }
};

export default manageState;
